var _style, _g, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _defs2, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _defs3, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _defs4, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _g2, _g3, _defs5, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _defs6, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _defs7, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _defs8, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _rect, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdlatusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1114 287",
    style: {
      enableBackground: "new 0 0 1114 287"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_00000116934964627306013740000010761291323055661986_);enable-background:new    ;}\n\t.st2{fill:#891318;}\n\t.st3{fill:#8D1319;}\n\t.st4{fill:#901319;}\n\t.st5{fill:#94131A;}\n\t.st6{fill:#97131A;}\n\t.st7{fill:#9B131B;}\n\t.st8{fill:#9E131B;}\n\t.st9{fill:#A2131C;}\n\t.st10{fill:#A82F25;}\n\t.st11{fill:#AB382A;}\n\t.st12{fill:#AD3F2E;}\n\t.st13{fill:#AE4431;}\n\t.st14{fill:#B04935;}\n\t.st15{fill:#B14E38;}\n\t.st16{fill:#B3523B;}\n\t.st17{fill:#B4553E;}\n\t.st18{fill:#B55941;}\n\t.st19{fill:#B65C44;}\n\t.st20{fill:#B85F47;}\n\t.st21{fill:#B9624A;}\n\t.st22{fill:#BA654D;}\n\t.st23{fill:#BB684F;}\n\t.st24{fill:#BC6B52;}\n\t.st25{fill:#BD6E55;}\n\t.st26{fill:#BE7057;}\n\t.st27{fill:#BE735A;}\n\t.st28{fill:#BF755C;}\n\t.st29{fill:#C0785F;}\n\t.st30{fill:#C17A61;}\n\t.st31{fill:#C27C64;}\n\t.st32{fill:#C37F66;}\n\t.st33{fill:#C38169;}\n\t.st34{fill:#C4836B;}\n\t.st35{clip-path:url(#SVGID_00000061470498775672698730000006016372447542707885_);enable-background:new    ;}\n\t.st36{clip-path:url(#SVGID_00000044163562103994496110000017997449014128726692_);enable-background:new    ;}\n\t.st37{fill:#490C0B;}\n\t.st38{fill:#4D0C0C;}\n\t.st39{fill:#510D0D;}\n\t.st40{fill:#550D0D;}\n\t.st41{fill:#590E0E;}\n\t.st42{fill:#5D0F0F;}\n\t.st43{fill:#611010;}\n\t.st44{fill:#651011;}\n\t.st45{fill:#681012;}\n\t.st46{fill:#6C1113;}\n\t.st47{fill:#701114;}\n\t.st48{fill:#741214;}\n\t.st49{fill:#771215;}\n\t.st50{fill:#7B1316;}\n\t.st51{fill:#7F1316;}\n\t.st52{fill:#821317;}\n\t.st53{fill:#861318;}\n\t.st54{clip-path:url(#SVGID_00000119811727209403979010000014021602646370440593_);enable-background:new    ;}\n\t.st55{fill:#871318;}\n\t.st56{clip-path:url(#SVGID_00000103263411022771666610000008886285260717966004_);enable-background:new    ;}\n\t.st57{clip-path:url(#SVGID_00000153667129983398579030000012801349772460636862_);enable-background:new    ;}\n\t.st58{clip-path:url(#SVGID_00000127725572649602678190000008564616756048200126_);enable-background:new    ;}\n\t.st59{clip-path:url(#SVGID_00000093856972707408880850000010613104115993045183_);enable-background:new    ;}\n\t.st60{fill:none;stroke:#DBDAD8;stroke-width:2;stroke-miterlimit:10;}\n\t.st61{fill:#FFFFFF;stroke:#D1D1D1;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hintergrund_CMYK"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M286.7,286.7H0.3c0,0,6.7-6.7,15-15h256.4C279.9,280,286.7,286.7,286.7,286.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041296631164775362910000014924286760429114789_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000041296631164775362910000014924286760429114789_)",
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.3,286.7h286.4l0,0H0.3L0.3,286.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.3,286.7h286.3c0,0-0.1-0.1-0.2-0.2H0.5C0.4,286.6,0.3,286.6,0.3,286.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0.5,286.5h285.9c-0.1-0.1-0.2-0.2-0.3-0.3H0.8C0.7,286.3,0.6,286.4,0.5,286.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0.8,286.2h285.3c-0.1-0.1-0.3-0.3-0.4-0.4H1.3C1.1,285.9,1,286,0.8,286.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1.3,285.7h284.4c-0.1-0.1-0.3-0.3-0.5-0.5H1.7C1.6,285.4,1.4,285.6,1.3,285.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1.7,285.2h283.4c-0.2-0.2-0.4-0.4-0.6-0.6H2.3C2.1,284.9,1.9,285.1,1.7,285.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2.3,284.7h282.3c-0.2-0.2-0.4-0.4-0.6-0.6H2.9C2.7,284.3,2.5,284.5,2.3,284.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2.9,284.1H284c-0.3-0.3-0.6-0.6-1-1H3.9C3.5,283.5,3.2,283.8,2.9,284.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3.9,283.1h279.2c-0.6-0.6-1.3-1.3-2-2H5.9C5.1,281.9,4.5,282.5,3.9,283.1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M5.9,281.1h275.2c-0.2-0.2-0.3-0.3-0.5-0.5H6.3C6.2,280.8,6,281,5.9,281.1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M6.3,280.7h274.3c-0.1-0.1-0.1-0.1-0.2-0.2H6.5C6.4,280.6,6.4,280.6,6.3,280.7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M6.5,280.5h273.9l-0.1-0.1H6.6C6.6,280.4,6.5,280.4,6.5,280.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M6.6,280.4h273.7l-0.1-0.1H6.8C6.7,280.3,6.7,280.3,6.6,280.4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M6.8,280.2h273.4l-0.1-0.1H6.9C6.8,280.2,6.8,280.2,6.8,280.2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M6.9,280.1h273.2L280,280H7L6.9,280.1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M7,280h272.9l-0.1-0.1H7.1L7,280"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M7.1,279.9h272.7l-0.1-0.1H7.3C7.2,279.8,7.2,279.8,7.1,279.9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M7.3,279.7h272.4l-0.1-0.1H7.4C7.3,279.7,7.3,279.7,7.3,279.7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M7.4,279.6h272.2l-0.1-0.1L7.4,279.6L7.4,279.6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M7.5,279.5h272l-0.1-0.1L7.5,279.5L7.5,279.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M7.5,279.5h271.9l-0.1-0.1L7.5,279.5C7.6,279.4,7.6,279.4,7.5,279.5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M7.6,279.4h271.7l-0.1-0.1L7.6,279.4C7.7,279.3,7.6,279.3,7.6,279.4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M7.7,279.3h271.5l-0.1-0.1L7.7,279.3C7.8,279.2,7.7,279.3,7.7,279.3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M7.8,279.2h271.4l-0.1-0.1L7.8,279.2C7.8,279.1,7.8,279.2,7.8,279.2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M7.9,279.1h271.2L279,279L7.9,279.1L7.9,279.1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M8,279h271l-0.1-0.1L8,279L8,279"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M8,279h270.8l-0.1-0.1L8,279C8.1,278.9,8.1,278.9,8,279"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M8.1,278.9h270.7l-0.1-0.1L8.1,278.9C8.2,278.8,8.2,278.8,8.1,278.9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M8.2,278.8h270.5l-0.1-0.1L8.2,278.8C8.3,278.7,8.2,278.8,8.2,278.8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M8.3,278.7h270.3l-0.1-0.1H8.4C8.4,278.6,8.3,278.6,8.3,278.7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M8.4,278.5h270c-0.2-0.2-0.5-0.5-0.7-0.7H9.2C8.9,278.1,8.7,278.3,8.4,278.5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M9.2,277.8h268.6c-0.1-0.1-0.2-0.2-0.3-0.3H9.5C9.4,277.6,9.3,277.7,9.2,277.8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M9.5,277.5h268l-0.1-0.1L9.5,277.5L9.5,277.5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M9.5,277.5h267.9l-0.1-0.1L9.5,277.5C9.6,277.4,9.6,277.4,9.5,277.5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M9.6,277.4h267.7l-0.1-0.1L9.6,277.4C9.7,277.3,9.6,277.3,9.6,277.4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M9.7,277.3h267.5l-0.1-0.1L9.7,277.3C9.8,277.2,9.7,277.3,9.7,277.3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M9.8,277.2h267.4l-0.1-0.1L9.8,277.2L9.8,277.2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M9.9,277.1h267.2L277,277L9.9,277.1L9.9,277.1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M10,277h267l-0.1-0.1L10,277L10,277"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M10,277h266.9l-0.1-0.1L10,277C10.1,276.9,10.1,276.9,10,277"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M10.1,276.9h266.7l-0.1-0.1L10.1,276.9C10.2,276.8,10.1,276.8,10.1,276.9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M10.2,276.8h266.5l-0.1-0.1L10.2,276.8C10.3,276.7,10.2,276.8,10.2,276.8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M10.3,276.7h266.4l-0.1-0.1L10.3,276.7C10.3,276.6,10.3,276.7,10.3,276.7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M10.4,276.6h266.2l-0.1-0.1L10.4,276.6L10.4,276.6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M10.5,276.5h266l-0.1-0.1L10.5,276.5L10.5,276.5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M10.5,276.4h265.8l-0.1-0.1H10.7C10.6,276.4,10.6,276.4,10.5,276.4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M10.7,276.3h265.6l-0.1-0.1H10.8C10.8,276.2,10.7,276.3,10.7,276.3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M10.8,276.2h265.3l-0.1-0.1H10.9C10.9,276.1,10.8,276.1,10.8,276.2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M10.9,276.1H276l-0.1-0.1H11.1C11,276,11,276,10.9,276.1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M11.1,275.9h264.8l-0.1-0.1H11.2C11.1,275.9,11.1,275.9,11.1,275.9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M11.2,275.8h264.6l-0.1-0.1H11.3C11.3,275.7,11.2,275.8,11.2,275.8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M11.3,275.7h264.3l-0.1-0.1H11.4C11.4,275.6,11.4,275.6,11.3,275.7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M11.4,275.6h264.1l-0.1-0.1H11.6C11.5,275.5,11.5,275.5,11.4,275.6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M11.6,275.4h263.8c-0.4-0.4-0.9-0.9-1.4-1.4H12.9C12.5,274.5,12,275,11.6,275.4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M12.9,274.1H274l-0.1-0.1H13.1C13,274,13,274,12.9,274.1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M13.1,273.9h260.8l-0.1-0.1H13.2C13.1,273.9,13.1,273.9,13.1,273.9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M13.2,273.8h260.6l-0.1-0.1H13.3C13.3,273.7,13.2,273.8,13.2,273.8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M13.3,273.7h260.3l-0.1-0.1H13.4C13.4,273.6,13.3,273.6,13.3,273.7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M13.4,273.6h260.1l-0.1-0.1H13.6C13.5,273.5,13.5,273.5,13.4,273.6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M13.6,273.4h259.8l-0.1-0.1H13.7C13.6,273.4,13.6,273.4,13.6,273.4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M13.7,273.3h259.6l-0.1-0.1H13.8C13.8,273.2,13.7,273.3,13.7,273.3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M13.8,273.2h259.3l-0.1-0.1H13.9L13.8,273.2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M13.9,273.1H273l-0.1-0.1H14C14,273,14,273,13.9,273.1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M14,272.9h258.8l-0.1-0.1L14,272.9C14.1,272.9,14.1,272.9,14,272.9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M14.1,272.9h258.7l-0.1-0.1L14.1,272.9C14.2,272.8,14.2,272.8,14.1,272.9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M14.2,272.8h258.5l-0.1-0.1L14.2,272.8C14.3,272.7,14.3,272.7,14.2,272.8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M14.3,272.7h258.3l-0.1-0.1L14.3,272.7C14.4,272.6,14.3,272.7,14.3,272.7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M14.4,272.6h258.1l-0.1-0.1L14.4,272.6C14.5,272.5,14.4,272.6,14.4,272.6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M14.5,272.5h258l-0.1-0.1L14.5,272.5C14.5,272.4,14.5,272.5,14.5,272.5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M14.6,272.4h257.8l-0.1-0.1L14.6,272.4L14.6,272.4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M14.7,272.3h257.6l-0.1-0.1L14.7,272.3L14.7,272.3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M14.8,272.2h257.4l-0.1-0.1L14.8,272.2L14.8,272.2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M14.8,272.1H272l-0.1-0.1L14.8,272.1C14.9,272.1,14.9,272.1,14.8,272.1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M14.9,272.1H272l-0.1-0.1L14.9,272.1C15,272,15,272,14.9,272.1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M15,272h256.9l-0.1-0.1L15,272C15.1,271.9,15.1,271.9,15,272"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M15.1,271.9h256.7l-0.1-0.1L15.1,271.9C15.2,271.8,15.1,271.9,15.1,271.9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M15.2,271.8h256.5c0,0,0,0-0.1-0.1L15.2,271.8C15.2,271.7,15.2,271.8,15.2,271.8"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003812332108775911830000015622693579555369107_",
    d: "M286.7,0.3v286.4c0,0-6.7-6.7-15-15V15.3 C279.9,7.1,286.7,0.3,286.7,0.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115505533265723232570000003918979728528496823_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003812332108775911830000015622693579555369107_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000115505533265723232570000003918979728528496823_)",
      enableBackground: "new"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.7,286.7V0.3l0,0V286.7L286.7,286.7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M286.6,286.7V0.4c0,0-0.1,0.1-0.2,0.2v285.9C286.5,286.6,286.6,286.7,286.6,286.7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M286.4,286.5V0.6c-0.1,0.1-0.2,0.2-0.4,0.4v285.1C286.2,286.3,286.3,286.4,286.4,286.5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M286,286.1V1c-0.1,0.1-0.3,0.3-0.5,0.5v284.1C285.7,285.8,285.9,286,286,286.1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M285.5,285.6V1.5c-0.2,0.2-0.4,0.4-0.6,0.6V285C285.1,285.2,285.3,285.4,285.5,285.6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M284.9,285V2.1c-0.2,0.2-0.4,0.4-0.7,0.7v281.6C284.5,284.6,284.7,284.8,284.9,285"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M284.3,284.3V2.8c-0.4,0.4-0.8,0.8-1.2,1.2v279.2C283.5,283.5,283.9,283.9,284.3,284.3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M283.1,283.1V3.9c-0.4,0.4-0.9,0.9-1.4,1.4v276.3C282.1,282.2,282.6,282.7,283.1,283.1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M281.6,281.7V5.4c-0.1,0.1-0.2,0.2-0.3,0.3v275.7C281.4,281.5,281.5,281.6,281.6,281.7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M281.3,281.4V5.7c-0.1,0.1-0.1,0.1-0.2,0.2v275.3C281.2,281.3,281.2,281.3,281.3,281.4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M281.1,281.2V5.9L281,6v275C281,281.1,281.1,281.1,281.1,281.2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M281,281V6c-0.1,0.1-0.1,0.1-0.2,0.2v274.6C280.8,280.9,280.9,281,281,281"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M280.8,280.9V6.2c-0.1,0.1-0.1,0.1-0.2,0.2v274.3C280.7,280.7,280.7,280.8,280.8,280.9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M280.6,280.7V6.4l-0.1,0.1v274C280.5,280.6,280.6,280.6,280.6,280.7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M280.5,280.5V6.5l-0.1,0.1L280.5,280.5C280.4,280.5,280.5,280.5,280.5,280.5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M280.4,280.5V6.6l-0.1,0.1L280.4,280.5C280.3,280.4,280.4,280.4,280.4,280.5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M280.3,280.4V6.7l-0.1,0.1L280.3,280.4C280.3,280.3,280.3,280.3,280.3,280.4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M280.2,280.3V6.8l-0.1,0.1L280.2,280.3C280.2,280.2,280.2,280.3,280.2,280.3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M280.1,280.2V6.9L280,7L280.1,280.2C280.1,280.1,280.1,280.2,280.1,280.2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M280.1,280.1V6.9C280,7,280,7,280,7L280.1,280.1C280,280.1,280,280.1,280.1,280.1"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M280,280V7l-0.1,0.1L280,280C279.9,280,279.9,280,280,280"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M279.9,279.9V7.1l-0.1,0.1L279.9,279.9C279.8,279.9,279.9,279.9,279.9,279.9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M279.8,279.9V7.2l-0.1,0.1L279.8,279.9C279.7,279.8,279.8,279.8,279.8,279.9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M279.7,279.8V7.3l-0.1,0.1L279.7,279.8C279.7,279.7,279.7,279.7,279.7,279.8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M279.6,279.7V7.4l-0.1,0.1v272.1C279.6,279.6,279.6,279.7,279.6,279.7"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M279.5,279.6V7.5l-0.1,0.1v271.8C279.4,279.5,279.5,279.5,279.5,279.6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M279.4,279.4V7.6l-0.1,0.1v271.6C279.3,279.4,279.3,279.4,279.4,279.4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M279.2,279.3V7.8l-0.1,0.1v271.3C279.2,279.2,279.2,279.3,279.2,279.3"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M279.1,279.2V7.9L279,8v271C279,279.1,279.1,279.1,279.1,279.2"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M279,279V8l-0.1,0.1v270.7C278.9,278.9,278.9,279,279,279"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M278.8,278.9V8.2l-0.1,0.1v270.5C278.7,278.8,278.8,278.9,278.8,278.9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M278.7,278.8V8.3c-0.1,0.1-0.2,0.2-0.3,0.3v269.9C278.5,278.6,278.6,278.7,278.7,278.8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M278.4,278.5V8.6l-0.1,0.1v269.7C278.3,278.4,278.4,278.5,278.4,278.5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M278.3,278.4V8.7l-0.1,0.1v269.4C278.2,278.3,278.3,278.3,278.3,278.4"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M278.2,278.2V8.8l-0.1,0.1v269.2C278.1,278.2,278.1,278.2,278.2,278.2"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M278,278.1V9l-0.1,0.1V278C278,278,278,278.1,278,278.1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M277.9,278V9.1l-0.1,0.1v268.6C277.8,277.9,277.9,277.9,277.9,278"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M277.8,277.9V9.2l-0.1,0.1v268.4C277.7,277.8,277.7,277.8,277.8,277.9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M277.7,277.7V9.3l-0.1,0.1v268.1C277.6,277.6,277.6,277.7,277.7,277.7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M277.5,277.6V9.5l-0.1,0.1L277.5,277.6C277.5,277.5,277.5,277.6,277.5,277.6"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M277.4,277.5V9.6l-0.1,0.1L277.4,277.5C277.4,277.4,277.4,277.5,277.4,277.5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M277.3,277.4V9.7l-0.1,0.1L277.3,277.4L277.3,277.4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M277.3,277.3V9.7l-0.1,0.1L277.3,277.3C277.2,277.3,277.2,277.3,277.3,277.3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M277.2,277.2V9.8l-0.1,0.1L277.2,277.2C277.1,277.2,277.1,277.2,277.2,277.2"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M277.1,277.2V9.9L277,10L277.1,277.2C277,277.1,277.1,277.1,277.1,277.2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M277,277.1V10l-0.1,0.1L277,277.1C276.9,277,277,277,277,277.1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M276.9,277V10.1l-0.1,0.1L276.9,277C276.9,276.9,276.9,276.9,276.9,277"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M276.8,276.9V10.2l-0.1,0.1L276.8,276.9C276.8,276.8,276.8,276.9,276.8,276.9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M276.7,276.8V10.3l-0.1,0.1L276.7,276.8C276.7,276.7,276.7,276.8,276.7,276.8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M276.7,276.7V10.4l-0.1,0.1L276.7,276.7C276.6,276.7,276.6,276.7,276.7,276.7"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M276.6,276.6V10.4l-0.1,0.1L276.6,276.6C276.5,276.6,276.5,276.6,276.6,276.6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M276.5,276.5v-266l-0.1,0.1v265.8C276.4,276.5,276.4,276.5,276.5,276.5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M276.3,276.4V10.7c-0.1,0.1-0.2,0.2-0.3,0.3v265.2C276.2,276.2,276.3,276.3,276.3,276.4"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M276.1,276.1V10.9c-0.1,0.1-0.2,0.2-0.3,0.3v264.6C275.9,275.9,276,276,276.1,276.1"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M275.8,275.8V11.2c-0.1,0.1-0.2,0.2-0.3,0.3v264C275.6,275.6,275.7,275.7,275.8,275.8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M275.5,275.5v-264c-0.3,0.3-0.5,0.5-0.8,0.8v262.4C274.9,275,275.2,275.3,275.5,275.5"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M274.7,274.7V12.3c-0.2,0.2-0.4,0.4-0.6,0.6v261.2C274.3,274.3,274.5,274.5,274.7,274.7"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M274.1,274.1V12.9L274,13v261C274,274.1,274,274.1,274.1,274.1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M274,274V13l-0.1,0.1v260.8C273.9,274,273.9,274,274,274"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M273.9,273.9V13.1l-0.1,0.1v260.6C273.8,273.8,273.8,273.9,273.9,273.9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M273.8,273.8V13.3l-0.1,0.1v260.4C273.7,273.7,273.7,273.8,273.8,273.8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M273.6,273.7V13.4l-0.1,0.1v260.1C273.6,273.6,273.6,273.7,273.6,273.7"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M273.5,273.6V13.5l-0.1,0.1v259.9C273.5,273.5,273.5,273.6,273.5,273.6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M273.4,273.5V13.6l-0.1,0.1v259.7C273.4,273.4,273.4,273.5,273.4,273.5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M273.3,273.4V13.7l-0.1,0.1v259.5C273.3,273.3,273.3,273.4,273.3,273.4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M273.2,273.3V13.8l-0.1,0.1v259.3C273.2,273.2,273.2,273.3,273.2,273.3"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M273.1,273.2V13.9L273,14v259.1C273,273.1,273.1,273.1,273.1,273.2"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M273,273.1V14l-0.1,0.1V273C272.9,273,273,273,273,273.1"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M272.9,273V14.1l-0.1,0.1v258.7C272.8,272.9,272.9,272.9,272.9,273"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M272.8,272.9V14.2l-0.1,0.1v258.4C272.7,272.8,272.8,272.8,272.8,272.9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M272.7,272.8V14.3l-0.1,0.1v258.2C272.6,272.7,272.7,272.7,272.7,272.8"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M272.6,272.7V14.4l-0.1,0.1v258C272.5,272.6,272.6,272.6,272.6,272.7"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M272.5,272.5v-258l-0.1,0.1v257.8C272.4,272.5,272.4,272.5,272.5,272.5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M272.4,272.4V14.6l-0.1,0.1v257.6C272.3,272.4,272.3,272.4,272.4,272.4"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M272.3,272.3V14.7l-0.1,0.1v257.4C272.2,272.3,272.2,272.3,272.3,272.3"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M272.2,272.2V14.8l-0.1,0.1v257.2C272.1,272.2,272.1,272.2,272.2,272.2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M272.1,272.1V14.9L272,15v257C272,272.1,272,272.1,272.1,272.1"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M272,272V15l-0.1,0.1v256.8C271.9,271.9,271.9,272,272,272"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M271.8,271.9V15.2l-0.1,0.1v256.5C271.8,271.8,271.8,271.9,271.8,271.9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M271.7,271.8V15.3l-0.1,0.1L271.7,271.8L271.7,271.8"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000016048918212079970840000007268665812478263192_",
    d: "M0.3,0.3h286.4c0,0-6.7,6.7-15,15H15.3 C7,7.1,0.3,0.3,0.3,0.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106863974635148760320000004463577879116426393_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016048918212079970840000007268665812478263192_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106863974635148760320000004463577879116426393_)",
      enableBackground: "new"
    }
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M286.7,0.3H0.3c0,0,0.1,0.1,0.4,0.4h285.5C286.5,0.5,286.7,0.3,286.7,0.3"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M286.2,0.8H0.7C0.8,0.9,1,1.1,1.2,1.3h284.5C285.9,1.1,286.1,0.9,286.2,0.8"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M285.7,1.3H1.2c0.2,0.2,0.3,0.3,0.5,0.5h283.5C285.4,1.6,285.6,1.4,285.7,1.3"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M285.2,1.8H1.7C1.9,1.9,2,2.1,2.2,2.3h282.5C284.9,2.1,285.1,1.9,285.2,1.8"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M284.7,2.3H2.2c0.2,0.2,0.3,0.3,0.5,0.5h281.5C284.4,2.6,284.5,2.5,284.7,2.3"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M284.2,2.8H2.7C2.9,3,3.1,3.1,3.2,3.3h280.5C283.9,3.1,284,3,284.2,2.8"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M283.7,3.3H3.2c0.2,0.2,0.3,0.3,0.5,0.5h279.5C283.4,3.6,283.6,3.5,283.7,3.3"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M283.2,3.8H3.7C3.9,3.9,4,4.1,4.2,4.2h278.6C282.9,4.1,283.1,3.9,283.2,3.8"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M282.8,4.2H4.2c0.2,0.2,0.3,0.3,0.5,0.5h277.6C282.4,4.6,282.6,4.4,282.8,4.2"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M282.3,4.7H4.6C4.8,4.9,4.9,5,5.1,5.2h276.7C282,5,282.1,4.9,282.3,4.7"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M281.8,5.2H5.1c0.2,0.2,0.3,0.3,0.5,0.5h275.8C281.5,5.5,281.7,5.3,281.8,5.2"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M281.4,5.6H5.6C5.7,5.8,5.8,5.9,6,6.1h274.9C281.1,5.9,281.2,5.8,281.4,5.6"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M280.9,6.1H6c0.1,0.1,0.3,0.3,0.5,0.5h274C280.6,6.4,280.8,6.2,280.9,6.1"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M280.5,6.5H6.5c0.1,0.1,0.3,0.3,0.4,0.4h273.2C280.2,6.8,280.3,6.7,280.5,6.5"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M280.1,6.9H6.9C7,7.1,7.2,7.2,7.3,7.4h272.3C279.8,7.2,279.9,7.1,280.1,6.9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M279.6,7.4H7.3c0.1,0.1,0.3,0.3,0.4,0.4h271.4C279.3,7.7,279.5,7.5,279.6,7.4"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M279.2,7.8H7.8C7.9,8,8.1,8.1,8.2,8.3h270.5C278.9,8.1,279,8,279.2,7.8"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.7,8.3H8.2c0.1,0.1,0.3,0.3,0.5,0.5h269.6C278.4,8.6,278.6,8.4,278.7,8.3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M278.3,8.7H8.7C8.8,8.9,9,9,9.1,9.2h268.7C278,9,278.1,8.9,278.3,8.7"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M277.8,9.2H9.1c0.2,0.2,0.3,0.3,0.5,0.5h267.7C277.5,9.5,277.6,9.4,277.8,9.2"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M277.3,9.7H9.6c0.2,0.2,0.3,0.3,0.5,0.5h266.7C277,10,277.2,9.8,277.3,9.7"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M276.8,10.2H10.1c0.2,0.2,0.3,0.3,0.5,0.5h265.7C276.5,10.5,276.7,10.3,276.8,10.2"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M276.3,10.7H10.6c0.2,0.2,0.4,0.4,0.6,0.6h264.6C275.9,11.1,276.1,10.9,276.3,10.7"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M275.7,11.3H11.1c0.2,0.2,0.4,0.4,0.5,0.5h263.5C275.4,11.6,275.6,11.4,275.7,11.3"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M275.2,11.8H11.7c0.1,0.1,0.2,0.2,0.3,0.3h262.9C275,12,275.1,11.9,275.2,11.8"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M274.9,12.1H12c0.1,0.1,0.2,0.2,0.3,0.3h262.2C274.7,12.3,274.8,12.2,274.9,12.1"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M274.6,12.4H12.3c0.1,0.1,0.2,0.2,0.3,0.3h261.6C274.4,12.6,274.5,12.5,274.6,12.4"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M274.3,12.7H12.7c0.1,0.1,0.1,0.1,0.2,0.2h261.2C274.1,12.9,274.2,12.8,274.3,12.7"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M274.1,12.9H12.9L13,13L274.1,12.9C274,13,274,13,274.1,12.9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M274,13H13l0.1,0.1L274,13C273.9,13.1,273.9,13.1,274,13"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M273.9,13.1H13.1l0.1,0.1L273.9,13.1C273.8,13.2,273.8,13.2,273.9,13.1"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M273.8,13.2H13.2l0.1,0.1L273.8,13.2C273.7,13.3,273.8,13.2,273.8,13.2"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M273.7,13.3H13.2l0.1,0.1L273.7,13.3C273.6,13.4,273.7,13.3,273.7,13.3"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M273.6,13.4H13.3l0.1,0.1L273.6,13.4C273.5,13.5,273.6,13.4,273.6,13.4"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M273.5,13.5H13.4l0.1,0.1L273.5,13.5C273.4,13.6,273.5,13.5,273.5,13.5"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M273.4,13.6H13.5l0.1,0.1L273.4,13.6L273.4,13.6"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M273.3,13.7H13.6l0.1,0.1L273.3,13.7L273.3,13.7"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M273.2,13.8H13.7l0.1,0.1L273.2,13.8L273.2,13.8"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M273.1,13.9H13.8l0.1,0.1L273.1,13.9L273.1,13.9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M273,14H13.9l0.1,0.1L273,14L273,14"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M273,14H14l0.1,0.1h258.8C272.9,14.1,272.9,14.1,273,14"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M272.8,14.2H14l0.1,0.1h258.5C272.8,14.2,272.8,14.2,272.8,14.2"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M272.7,14.3H14.2l0.1,0.1h258.2C272.6,14.4,272.7,14.3,272.7,14.3"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M272.6,14.4H14.4l0.1,0.1h258C272.5,14.5,272.5,14.5,272.6,14.4"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M272.4,14.6h-258l0.1,0.1h257.7C272.4,14.7,272.4,14.6,272.4,14.6"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M272.3,14.7H14.6l0.1,0.1h257.4C272.2,14.8,272.3,14.7,272.3,14.7"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M272.2,14.8H14.8l0.1,0.1H272C272.1,14.9,272.1,14.9,272.2,14.8"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M272,15H14.9l0.1,0.1h256.9L272,15"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M271.9,15.1H15l0.1,0.1h256.6C271.8,15.2,271.9,15.1,271.9,15.1"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M271.8,15.2H15.2l0.1,0.1L271.8,15.2C271.7,15.3,271.7,15.3,271.8,15.2"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000093894333106385019020000007072961552263686331_",
    d: "M0.3,286.7V0.3c0,0,6.7,6.7,15,15v256.4 C7,280,0.3,286.7,0.3,286.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003102789452488580660000009527721172731339674_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093894333106385019020000007072961552263686331_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003102789452488580660000009527721172731339674_)",
      enableBackground: "new"
    }
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M0.3,0.3v286.4c0,0,0.2-0.2,0.6-0.6V0.9C0.5,0.5,0.3,0.3,0.3,0.3"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M0.8,0.9v285.3c0.2-0.2,0.3-0.3,0.6-0.6V1.5C1.2,1.3,1,1.1,0.8,0.9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M1.4,1.5v284.1c0.2-0.2,0.3-0.3,0.5-0.5V2C1.7,1.8,1.6,1.6,1.4,1.5"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M1.9,2v283.1c0.2-0.2,0.3-0.3,0.5-0.5V2.5C2.3,2.3,2.1,2.2,1.9,2"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M2.4,2.5v282c0.2-0.2,0.3-0.3,0.5-0.5V3C2.8,2.8,2.6,2.7,2.4,2.5"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M2.9,3v281c0.2-0.2,0.3-0.3,0.5-0.5V3.5C3.3,3.3,3.1,3.2,2.9,3"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M3.4,3.5v280.1c0.2-0.2,0.3-0.3,0.5-0.5V4C3.7,3.8,3.6,3.7,3.4,3.5"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M3.9,4v279.1c0.1-0.1,0.3-0.3,0.5-0.5V4.4C4.2,4.3,4.1,4.1,3.9,4"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M4.4,4.4v278.2c0.1-0.1,0.3-0.3,0.5-0.5V4.9C4.7,4.7,4.5,4.6,4.4,4.4"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M4.8,4.9v277.3c0.1-0.1,0.3-0.3,0.4-0.4V5.3C5.1,5.2,5,5,4.8,4.9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M5.3,5.3v276.4c0.1-0.1,0.3-0.3,0.4-0.4V5.8C5.5,5.6,5.4,5.5,5.3,5.3"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M5.7,5.8v275.5c0.1-0.1,0.3-0.3,0.4-0.4V6.2C6,6,5.8,5.9,5.7,5.8"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M6.1,6.2v274.7c0.1-0.1,0.3-0.3,0.4-0.4V6.6C6.4,6.5,6.3,6.3,6.1,6.2"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M6.5,6.6v273.8c0.1-0.1,0.3-0.3,0.4-0.4V7C6.8,6.9,6.7,6.8,6.5,6.6"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M7,7v273c0.1-0.1,0.3-0.3,0.4-0.4V7.5C7.2,7.3,7.1,7.2,7,7"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M7.4,7.5v272.2c0.1-0.1,0.3-0.3,0.4-0.4V7.9C7.7,7.7,7.5,7.6,7.4,7.5"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M7.8,7.9v271.3c0.1-0.1,0.3-0.3,0.4-0.4V8.3C8.1,8.1,7.9,8,7.8,7.9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.2,8.3v270.5c0.1-0.1,0.3-0.3,0.4-0.4V8.7C8.5,8.6,8.4,8.4,8.2,8.3"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.6,8.7v269.6c0.1-0.1,0.3-0.3,0.4-0.4V9.1C8.9,9,8.8,8.9,8.6,8.7"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.1,9.1v268.8c0.1-0.1,0.3-0.3,0.4-0.4V9.6C9.4,9.4,9.2,9.3,9.1,9.1"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M9.5,9.6v267.9c0.2-0.2,0.3-0.3,0.5-0.5V10C9.8,9.9,9.7,9.7,9.5,9.6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M10,10v267c0.2-0.2,0.3-0.3,0.5-0.5v-266C10.3,10.3,10.1,10.2,10,10"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.4,10.5v266.1c0.2-0.2,0.3-0.3,0.5-0.5V11C10.8,10.8,10.6,10.7,10.4,10.5"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M10.9,11v265c0.2-0.2,0.3-0.3,0.5-0.5v-264C11.3,11.4,11.1,11.2,10.9,11"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.5,11.5v264c0.2-0.2,0.3-0.3,0.5-0.5V12C11.8,11.9,11.6,11.7,11.5,11.5"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M12,12v263c0.2-0.2,0.3-0.3,0.5-0.5v-262C12.3,12.4,12.1,12.2,12,12"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M12.5,12.5v262c0.1-0.1,0.3-0.3,0.4-0.4V12.9C12.7,12.8,12.6,12.7,12.5,12.5"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M12.9,12.9v261.2L13,274V13C12.9,13,12.9,13,12.9,12.9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M13,13v261l0.1-0.1V13.1C13,13.1,13,13.1,13,13"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M13.1,13.1v260.8l0.1-0.1V13.3C13.1,13.2,13.1,13.2,13.1,13.1"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M13.2,13.3v260.6l0.1-0.1V13.4C13.2,13.3,13.2,13.3,13.2,13.3"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M13.3,13.4v260.4l0.1-0.1V13.5C13.4,13.4,13.3,13.4,13.3,13.4"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M13.4,13.5v260.1l0.1-0.1V13.6C13.5,13.5,13.4,13.5,13.4,13.5"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M13.5,13.6v259.9l0.1-0.1V13.7C13.6,13.6,13.5,13.6,13.5,13.6"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M13.6,13.7v259.7l0.1-0.1V13.8C13.7,13.7,13.6,13.7,13.6,13.7"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M13.7,13.8v259.5l0.1-0.1V13.9C13.8,13.8,13.7,13.8,13.7,13.8"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M13.8,13.9v259.3l0.1-0.1V14C13.9,14,13.8,13.9,13.8,13.9"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M13.9,14v259.1L14,273V14.1C14,14.1,14,14,13.9,14"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M14,14.1V273l0.1-0.1V14.2C14.1,14.2,14.1,14.1,14,14.1"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M14.1,14.2v258.7l0.1-0.1V14.3C14.2,14.3,14.2,14.2,14.1,14.2"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M14.2,14.3v258.4l0.1-0.1V14.4C14.3,14.4,14.3,14.3,14.2,14.3"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M14.3,14.4v258.2l0.1-0.1v-258C14.4,14.5,14.4,14.4,14.3,14.4"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M14.4,14.5v258l0.1-0.1V14.6C14.5,14.6,14.5,14.6,14.4,14.5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M14.6,14.6v257.8l0.1-0.1V14.7C14.6,14.7,14.6,14.7,14.6,14.6"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M14.7,14.7v257.6l0.1-0.1V14.8C14.7,14.8,14.7,14.8,14.7,14.7"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M14.8,14.8v257.4l0.1-0.1V14.9C14.8,14.9,14.8,14.9,14.8,14.8"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M14.9,14.9v257.2L15,272V15C14.9,15,14.9,15,14.9,14.9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M15,15v257l0.1-0.1V15.2C15,15.1,15,15.1,15,15"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M15.1,15.2V272l0.1-0.1V15.3C15.2,15.2,15.1,15.2,15.1,15.2"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M15.2,15.3v256.5l0.1-0.1L15.2,15.3L15.2,15.3"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "0.3,286.7 286.7,286.7 286.7,286.7  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "0.3,0.3 286.7,0.3 286.7,0.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000008108286119192372250000014479555347428359868_",
    d: "M271.7,271.7c8.3,8.3,15,15,15,15H0.3 c0,0,6.7-6.7,15-15H271.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091005602744811425300000012954885503517544123_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008108286119192372250000014479555347428359868_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091005602744811425300000012954885503517544123_)",
      enableBackground: "new"
    }
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M15.3,271.7h256.4l0.1,0.1L15.3,271.7C15.2,271.8,15.2,271.8,15.3,271.7"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M15.2,271.8h256.6l0.1,0.1H15C15.1,271.9,15.1,271.9,15.2,271.8"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M15,272h256.9l0.1,0.1H14.9L15,272"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M14.9,272.1H272l0.1,0.1H14.8L14.9,272.1"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M14.8,272.2h257.4l0.1,0.1H14.6C14.7,272.3,14.7,272.3,14.8,272.2"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M14.6,272.4h257.7l0.1,0.1h-258C14.5,272.5,14.6,272.4,14.6,272.4"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M14.5,272.5h258l0.1,0.1H14.4C14.4,272.6,14.4,272.5,14.5,272.5"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M14.4,272.6h258.2l0.1,0.1H14.2C14.3,272.7,14.3,272.7,14.4,272.6"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M14.2,272.8h258.5l0.1,0.1H14.1L14.2,272.8"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M14.1,272.9h258.8l0.1,0.1H14C14,273,14,272.9,14.1,272.9"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M14,273h259l0.1,0.1L14,273C13.9,273.1,13.9,273,14,273"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M13.9,273.1H273l0.1,0.1L13.9,273.1C13.8,273.2,13.9,273.1,13.9,273.1"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M13.8,273.2h259.3l0.1,0.1L13.8,273.2C13.7,273.3,13.8,273.2,13.8,273.2"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M13.7,273.3h259.5l0.1,0.1L13.7,273.3C13.6,273.4,13.7,273.3,13.7,273.3"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M13.6,273.4h259.7l0.1,0.1L13.6,273.4C13.5,273.4,13.6,273.4,13.6,273.4"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M13.5,273.5h259.9l0.1,0.1L13.5,273.5L13.5,273.5"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M13.4,273.6h260.1l0.1,0.1L13.4,273.6L13.4,273.6"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M13.3,273.7h260.3l0.1,0.1L13.3,273.7L13.3,273.7"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M13.2,273.8h260.5l0.1,0.1L13.2,273.8L13.2,273.8"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M13.1,273.8h260.6l0.1,0.1L13.1,273.8C13.1,273.9,13.1,273.9,13.1,273.8"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M13.1,273.9h260.8l0.1,0.1L13.1,273.9C13,274,13,274,13.1,273.9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M13,274h261l0.1,0.1L13,274C12.9,274.1,12.9,274.1,13,274"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M12.9,274.1h261.2c0.1,0.1,0.1,0.1,0.2,0.2H12.7C12.7,274.3,12.8,274.2,12.9,274.1"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M12.7,274.3h261.6c0.1,0.1,0.2,0.2,0.3,0.3H12.3C12.4,274.5,12.6,274.4,12.7,274.3"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M12.3,274.7h262.2c0.1,0.1,0.2,0.2,0.3,0.3H12C12.1,274.9,12.2,274.8,12.3,274.7"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12,275h262.9c0.1,0.1,0.2,0.2,0.3,0.3H11.7C11.8,275.2,11.9,275.1,12,275"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M11.7,275.3h263.5c0.2,0.2,0.4,0.4,0.5,0.5H11.2C11.4,275.6,11.5,275.5,11.7,275.3"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M11.2,275.8h264.6c0.2,0.2,0.4,0.4,0.6,0.6H10.6C10.8,276.2,11,276,11.2,275.8"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M10.6,276.4h265.7c0.2,0.2,0.3,0.3,0.5,0.5H10.1C10.3,276.7,10.4,276.5,10.6,276.4"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M10.1,276.9h266.7c0.2,0.2,0.3,0.3,0.5,0.5H9.6C9.8,277.2,9.9,277.1,10.1,276.9"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.6,277.4h267.7c0.2,0.2,0.3,0.3,0.5,0.5H9.1C9.3,277.7,9.4,277.6,9.6,277.4"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.1,277.9h268.7c0.2,0.2,0.3,0.3,0.5,0.5H8.7C8.8,278.2,9,278,9.1,277.9"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.7,278.3h269.6c0.2,0.2,0.3,0.3,0.5,0.5H8.2C8.4,278.6,8.5,278.5,8.7,278.3"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M8.2,278.8h270.5c0.2,0.2,0.3,0.3,0.4,0.4H7.8C7.9,279.1,8.1,278.9,8.2,278.8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M7.8,279.2h271.4c0.1,0.1,0.3,0.3,0.4,0.4H7.3C7.5,279.5,7.6,279.4,7.8,279.2"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M7.3,279.7h272.3c0.2,0.2,0.3,0.3,0.4,0.4H6.9C7,280,7.2,279.8,7.3,279.7"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M6.9,280.1h273.2c0.1,0.1,0.3,0.3,0.4,0.4H6.4C6.6,280.4,6.7,280.3,6.9,280.1"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M6.4,280.5h274c0.2,0.2,0.3,0.3,0.5,0.5H6C6.1,280.9,6.3,280.7,6.4,280.5"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M6,281h274.9c0.1,0.1,0.3,0.3,0.4,0.4H5.6C5.7,281.3,5.8,281.1,6,281"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M5.6,281.4h275.8c0.2,0.2,0.3,0.3,0.5,0.5H5.1C5.2,281.7,5.4,281.6,5.6,281.4"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M5.1,281.9h276.7c0.2,0.2,0.3,0.3,0.4,0.4H4.6C4.8,282.2,4.9,282.1,5.1,281.9"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M4.6,282.3h277.6c0.2,0.2,0.3,0.3,0.5,0.5H4.2C4.3,282.7,4.5,282.5,4.6,282.3"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M4.2,282.8h278.6c0.2,0.2,0.3,0.3,0.5,0.5H3.7C3.9,283.1,4,283,4.2,282.8"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M3.7,283.3h279.5c0.2,0.2,0.3,0.3,0.5,0.5H3.2C3.4,283.6,3.5,283.5,3.7,283.3"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M3.2,283.8h280.5c0.2,0.2,0.3,0.3,0.5,0.5H2.7C2.9,284.1,3.1,283.9,3.2,283.8"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M2.7,284.3h281.5c0.2,0.2,0.3,0.3,0.5,0.5H2.2C2.4,284.6,2.6,284.4,2.7,284.3"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M2.2,284.8h282.5c0.2,0.2,0.4,0.4,0.5,0.5H1.7C1.9,285.1,2,284.9,2.2,284.8"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M1.7,285.3h283.5c0.2,0.2,0.4,0.4,0.5,0.5H1.2C1.4,285.6,1.5,285.5,1.7,285.3"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M1.2,285.8h284.5c0.2,0.2,0.4,0.4,0.5,0.5H0.7C0.8,286.2,1,286,1.2,285.8"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M0.7,286.3h285.5c0.3,0.3,0.4,0.4,0.4,0.4H0.3C0.3,286.7,0.4,286.6,0.7,286.3"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000075849478556304234850000018089231856939798433_",
    d: "M271.7,15.3c8.3-8.3,15-15,15-15v286.4 c0,0-6.7-6.7-15-15C271.7,271.7,271.7,15.3,271.7,15.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110466119685525238100000008497380593367629718_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075849478556304234850000018089231856939798433_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000110466119685525238100000008497380593367629718_)",
      enableBackground: "new"
    }
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M271.7,271.7V15.3l0.1-0.1L271.7,271.7C271.7,271.8,271.7,271.8,271.7,271.7"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M271.7,271.8V15.3l0.1-0.1V272C271.8,271.9,271.8,271.8,271.7,271.8"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M271.8,271.9V15.2l0.1-0.1v257C271.9,272,271.9,271.9,271.8,271.9"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M272,272V15l0.1-0.1v257.2C272,272.1,272,272.1,272,272"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M272.1,272.1V14.9l0.1-0.1v257.4C272.1,272.2,272.1,272.2,272.1,272.1"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M272.2,272.2V14.8l0.1-0.1v257.6C272.2,272.3,272.2,272.3,272.2,272.2"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M272.3,272.3V14.7l0.1-0.1v257.8C272.3,272.4,272.3,272.4,272.3,272.3"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M272.4,272.4V14.6l0.1-0.1v258C272.4,272.5,272.4,272.5,272.4,272.4"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M272.5,272.5v-258l0.1-0.1v258.2C272.6,272.6,272.5,272.6,272.5,272.5"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M272.6,272.7V14.4l0.1-0.1v258.4C272.7,272.7,272.6,272.7,272.6,272.7"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M272.7,272.8V14.3l0.1-0.1v258.7C272.8,272.8,272.7,272.8,272.7,272.8"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M272.8,272.9V14.2l0.1-0.1V273C272.9,272.9,272.8,272.9,272.8,272.9"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M272.9,273V14.1L273,14v259.1C273,273,272.9,273,272.9,273"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M273,273.1V14l0.1-0.1v259.3C273.1,273.1,273,273.1,273,273.1"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M273.1,273.2V13.9l0.1-0.1v259.5C273.2,273.3,273.2,273.2,273.1,273.2"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M273.2,273.3V13.8l0.1-0.1v259.7C273.3,273.4,273.3,273.3,273.2,273.3"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M273.3,273.4V13.7l0.1-0.1v259.9C273.4,273.5,273.4,273.4,273.3,273.4"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M273.4,273.5V13.6l0.1-0.1v260.1C273.5,273.6,273.5,273.5,273.4,273.5"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M273.5,273.6V13.5l0.1-0.1v260.4C273.6,273.7,273.6,273.6,273.5,273.6"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M273.6,273.7V13.4l0.1-0.1v260.6C273.7,273.8,273.7,273.7,273.6,273.7"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M273.8,273.8V13.3l0.1-0.1V274C273.8,273.9,273.8,273.8,273.8,273.8"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M273.9,273.9V13.1L274,13v261C273.9,274,273.9,274,273.9,273.9"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M274,274V13l0.1-0.1v261.2C274,274.1,274,274.1,274,274"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M274.1,274.1V12.9c0.1-0.1,0.3-0.3,0.4-0.4v262C274.3,274.4,274.2,274.3,274.1,274.1"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M274.5,274.5v-262c0.2-0.2,0.3-0.3,0.5-0.5v263C274.8,274.9,274.6,274.7,274.5,274.5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M275,275V12c0.2-0.2,0.3-0.3,0.5-0.5v264C275.3,275.4,275.1,275.2,275,275"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M275.5,275.5v-264c0.2-0.2,0.4-0.4,0.5-0.5v265C275.8,275.9,275.6,275.7,275.5,275.5"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M276,276.1V11c0.2-0.2,0.3-0.3,0.5-0.5v266.1C276.3,276.4,276.2,276.2,276,276.1"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M276.5,276.6V10.5c0.2-0.2,0.3-0.3,0.5-0.5v267C276.8,276.9,276.7,276.7,276.5,276.6"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M277,277V10c0.2-0.2,0.3-0.3,0.5-0.5v267.9C277.3,277.3,277.1,277.2,277,277"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M277.4,277.5V9.6c0.1-0.1,0.3-0.3,0.4-0.4V278C277.7,277.8,277.6,277.6,277.4,277.5"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M277.9,277.9V9.1c0.1-0.1,0.3-0.3,0.4-0.4v269.6C278.1,278.2,278,278.1,277.9,277.9"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.3,278.4V8.7c0.1-0.1,0.3-0.3,0.4-0.4v270.5C278.6,278.6,278.4,278.5,278.3,278.4"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M278.7,278.8V8.3c0.1-0.1,0.3-0.3,0.4-0.4v271.3C279,279.1,278.9,278.9,278.7,278.8"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M279.1,279.2V7.9c0.1-0.1,0.3-0.3,0.4-0.4v272.2C279.4,279.5,279.3,279.3,279.1,279.2"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M279.5,279.6V7.5c0.1-0.1,0.3-0.3,0.4-0.4v273C279.8,279.9,279.7,279.8,279.5,279.6"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M280,280V7c0.1-0.1,0.3-0.3,0.4-0.4v273.8C280.2,280.3,280.1,280.2,280,280"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M280.4,280.4V6.6c0.1-0.1,0.3-0.3,0.4-0.4v274.7C280.7,280.7,280.5,280.6,280.4,280.4"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M280.8,280.9V6.2c0.1-0.1,0.3-0.3,0.4-0.4v275.5C281.1,281.2,281,281,280.8,280.9"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M281.2,281.3V5.8c0.1-0.1,0.3-0.3,0.4-0.4v276.4C281.5,281.6,281.4,281.5,281.2,281.3"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M281.7,281.7V5.3c0.1-0.1,0.3-0.3,0.4-0.4v277.3C282,282,281.8,281.9,281.7,281.7"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M282.1,282.2V4.9c0.2-0.2,0.3-0.3,0.5-0.5v278.2C282.4,282.5,282.3,282.3,282.1,282.2"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M282.6,282.6V4.4c0.2-0.2,0.3-0.3,0.5-0.5V283C282.9,282.9,282.7,282.8,282.6,282.6"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M283,283.1V4c0.2-0.2,0.3-0.3,0.5-0.5v280.1C283.3,283.4,283.2,283.3,283,283.1"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M283.5,283.6V3.5c0.2-0.2,0.3-0.3,0.5-0.5v281C283.8,283.9,283.7,283.7,283.5,283.6"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M284,284.1V3c0.2-0.2,0.3-0.3,0.5-0.5v282C284.3,284.4,284.2,284.2,284,284.1"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M284.5,284.5V2.5c0.2-0.2,0.4-0.4,0.5-0.5v283.1C284.8,284.9,284.7,284.7,284.5,284.5"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M285,285.1V2c0.2-0.2,0.4-0.4,0.5-0.5v284.1C285.4,285.4,285.2,285.3,285,285.1"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M285.5,285.6V1.5c0.2-0.2,0.4-0.4,0.6-0.6v285.3C285.9,286,285.7,285.8,285.5,285.6"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M286.1,286.2V0.9c0.4-0.4,0.6-0.6,0.6-0.6v286.4C286.7,286.7,286.5,286.5,286.1,286.2"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000136377361378464621330000008606896931635997067_",
    d: "M15.3,15.3C7,7,0.3,0.3,0.3,0.3h286.4 c0,0-6.7,6.7-15,15H15.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098221447260613350960000008275142587034140839_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136377361378464621330000008606896931635997067_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000098221447260613350960000008275142587034140839_)",
      enableBackground: "new"
    }
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M271.7,15.3H15.3c0,0,0,0-0.1-0.1L271.7,15.3L271.7,15.3"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M271.7,15.3H15.2l-0.1-0.1L271.7,15.3C271.8,15.2,271.8,15.2,271.7,15.3"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M271.8,15.2H15.1L15,15.1L271.8,15.2C271.9,15.1,271.8,15.2,271.8,15.2"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M271.9,15.1H15L14.9,15L271.9,15.1C272,15,271.9,15.1,271.9,15.1"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M272,15H14.9l-0.1-0.1L272,15C272.1,14.9,272,15,272,15"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M272.1,14.9H14.8l-0.1-0.1L272.1,14.9L272.1,14.9"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M272.2,14.8H14.8l-0.1-0.1L272.2,14.8L272.2,14.8"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M272.3,14.7H14.7l-0.1-0.1L272.3,14.7L272.3,14.7"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M272.4,14.6H14.6l-0.1-0.1L272.4,14.6L272.4,14.6"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M272.4,14.6h-258l-0.1-0.1L272.4,14.6C272.5,14.5,272.5,14.5,272.4,14.6"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M272.5,14.5H14.4l-0.1-0.1L272.5,14.5C272.6,14.4,272.6,14.4,272.5,14.5"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M272.6,14.4H14.3l-0.1-0.1L272.6,14.4C272.7,14.3,272.6,14.4,272.6,14.4"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M272.7,14.3H14.2l-0.1-0.1L272.7,14.3C272.8,14.2,272.7,14.3,272.7,14.3"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M272.8,14.2H14.1L14,14.1L272.8,14.2C272.9,14.1,272.8,14.2,272.8,14.2"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M272.9,14.1H14L13.9,14H273L272.9,14.1"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M273,14H13.9l-0.1-0.1h259.3C273.1,13.9,273,14,273,14"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M273.1,13.9H13.8l-0.1-0.1h259.6C273.2,13.8,273.2,13.8,273.1,13.9"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M273.3,13.7H13.7l-0.1-0.1h259.8C273.3,13.7,273.3,13.7,273.3,13.7"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M273.4,13.6H13.6l-0.1-0.1h260.1C273.5,13.5,273.4,13.6,273.4,13.6"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M273.5,13.5H13.4l-0.1-0.1h260.3C273.6,13.4,273.5,13.5,273.5,13.5"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M273.6,13.4H13.3l-0.1-0.1h260.6C273.7,13.3,273.7,13.3,273.6,13.4"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M273.7,13.3H13.2l-0.1-0.1h260.8C273.8,13.2,273.8,13.2,273.7,13.3"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M273.9,13.1H13.1L13,13h261C273.9,13.1,273.9,13.1,273.9,13.1"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M274,13H12.9c-0.5-0.5-0.9-0.9-1.4-1.4h263.8C274.9,12.1,274.5,12.5,274,13"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M275.4,11.6H11.6l-0.1-0.1h264.1C275.4,11.6,275.4,11.6,275.4,11.6"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M275.5,11.5H11.4l-0.1-0.1h264.3C275.6,11.4,275.5,11.5,275.5,11.5"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M275.6,11.4H11.3l-0.1-0.1h264.6C275.7,11.3,275.7,11.3,275.6,11.4"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M275.7,11.3H11.2l-0.1-0.1h264.8C275.8,11.2,275.8,11.2,275.7,11.3"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M275.9,11.1H11.1L11,11h265L275.9,11.1"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M276,11H10.9l-0.1-0.1h265.3C276.1,10.9,276,11,276,11"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M276.1,10.9H10.8l-0.1-0.1h265.6C276.2,10.8,276.2,10.8,276.1,10.9"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M276.3,10.7H10.7l-0.1-0.1h265.8C276.3,10.7,276.3,10.7,276.3,10.7"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M276.4,10.6H10.5l-0.1-0.1L276.4,10.6L276.4,10.6"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M276.5,10.5h-266l-0.1-0.1L276.5,10.5L276.5,10.5"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M276.6,10.4H10.4l-0.1-0.1L276.6,10.4L276.6,10.4"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M276.6,10.4H10.3l-0.1-0.1L276.6,10.4C276.7,10.3,276.7,10.3,276.6,10.4"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M276.7,10.3H10.2l-0.1-0.1L276.7,10.3C276.8,10.2,276.8,10.2,276.7,10.3"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M276.8,10.2H10.1L10,10.1L276.8,10.2C276.9,10.1,276.8,10.2,276.8,10.2"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M276.9,10.1H10L9.9,10L276.9,10.1L276.9,10.1"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M277,10H10L9.9,9.9L277,10L277,10"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M277.1,9.9H9.9L9.8,9.8L277.1,9.9L277.1,9.9"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M277.1,9.9H9.8L9.7,9.8L277.1,9.9C277.2,9.8,277.2,9.8,277.1,9.9"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M277.2,9.8H9.7L9.6,9.7L277.2,9.8C277.3,9.7,277.3,9.7,277.2,9.8"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M277.3,9.7H9.6L9.5,9.6L277.3,9.7C277.4,9.6,277.3,9.7,277.3,9.7"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M277.4,9.6H9.5L9.4,9.5L277.4,9.6L277.4,9.6"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M277.5,9.5H9.5C9.4,9.4,9.3,9.3,9.2,9.2h268.6C277.7,9.3,277.6,9.4,277.5,9.5"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M277.8,9.2H9.2C8.9,9,8.7,8.8,8.4,8.5h270C278.2,8.8,278,9,277.8,9.2"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M278.5,8.5H8.4L8.3,8.4h270.3C278.6,8.4,278.5,8.5,278.5,8.5"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M278.6,8.4H8.3L8.2,8.3L278.6,8.4C278.7,8.3,278.7,8.3,278.6,8.4"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M278.7,8.3H8.2L8.1,8.2L278.7,8.3C278.8,8.2,278.7,8.3,278.7,8.3"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M278.8,8.2H8.1L8,8.1L278.8,8.2C278.9,8.1,278.8,8.2,278.8,8.2"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M278.9,8.1H8c0,0,0,0,0-0.1L278.9,8.1L278.9,8.1"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M279,8H8L7.9,7.9L279,8L279,8"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M279.1,7.9H7.9L7.8,7.8L279.1,7.9L279.1,7.9"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M279.1,7.9H7.8L7.7,7.8L279.1,7.9C279.2,7.8,279.2,7.8,279.1,7.9"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M279.2,7.8H7.7L7.6,7.7L279.2,7.8C279.3,7.7,279.3,7.7,279.2,7.8"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M279.3,7.7H7.6L7.5,7.6L279.3,7.7C279.4,7.6,279.3,7.7,279.3,7.7"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M279.4,7.6H7.5L7.4,7.5L279.4,7.6L279.4,7.6"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M279.5,7.5H7.5L7.4,7.4L279.5,7.5L279.5,7.5"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M279.6,7.4H7.4L7.3,7.3L279.6,7.4C279.6,7.4,279.6,7.4,279.6,7.4"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M279.7,7.3H7.3L7.2,7.2h272.7C279.8,7.2,279.7,7.3,279.7,7.3"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M279.8,7.2H7.1L7,7.1h272.9L279.8,7.2"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M279.9,7.1H7C7,7,6.9,7,6.9,6.9h273.2C280,7,280,7,279.9,7.1"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M280.1,6.9H6.9L6.8,6.8L280.1,6.9C280.1,6.9,280.1,6.9,280.1,6.9"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M280.2,6.8H6.8L6.7,6.7h273.7C280.3,6.7,280.2,6.8,280.2,6.8"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M280.3,6.7H6.6L6.5,6.6h273.9L280.3,6.7"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M280.4,6.6H6.5C6.4,6.5,6.4,6.4,6.3,6.4h274.3C280.6,6.4,280.5,6.5,280.4,6.6"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M280.6,6.4H6.3C6.2,6.2,6,6.1,5.9,5.9h275.2C280.9,6.1,280.8,6.2,280.6,6.4"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M281.1,5.9H5.9c-0.7-0.7-1.4-1.4-2-2h279.2C282.5,4.5,281.8,5.2,281.1,5.9"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M283.1,3.9H3.9c-0.3-0.3-0.7-0.7-1-1H284C283.7,3.3,283.4,3.6,283.1,3.9"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M284,3H2.9C2.7,2.8,2.5,2.6,2.3,2.4h282.3C284.4,2.6,284.2,2.8,284,3"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M284.6,2.4H2.3C2.1,2.2,1.9,2,1.7,1.8h283.4C285,2,284.8,2.2,284.6,2.4"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M285.2,1.8H1.7C1.6,1.6,1.4,1.5,1.3,1.3h284.4C285.5,1.5,285.4,1.6,285.2,1.8"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M285.7,1.3H1.3C1.1,1.2,1,1,0.8,0.9h285.3C286,1,285.8,1.2,285.7,1.3"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M286.1,0.9H0.8C0.7,0.8,0.6,0.7,0.5,0.6h285.9C286.3,0.7,286.2,0.8,286.1,0.9"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.4,0.6H0.5C0.4,0.5,0.3,0.4,0.3,0.4h286.3C286.6,0.4,286.5,0.5,286.4,0.6"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.6,0.4H0.3l0,0H286.6C286.7,0.3,286.7,0.4,286.6,0.4"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000070095060343258013090000015707211707681122711_",
    d: "M15.3,271.7c-8.3,8.3-15,15-15,15V0.3 c0,0,6.7,6.7,15,15V271.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072964388278088380510000012411524001348221599_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070095060343258013090000015707211707681122711_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072964388278088380510000012411524001348221599_)",
      enableBackground: "new"
    }
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M15.3,15.3v256.4l-0.1,0.1L15.3,15.3C15.2,15.3,15.2,15.3,15.3,15.3"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M15.2,15.3v256.5l-0.1,0.1V15.2C15.1,15.2,15.2,15.2,15.2,15.3"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M15.1,15.2V272l-0.1,0.1V15C15,15.1,15,15.1,15.1,15.2"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M15,15v257l-0.1,0.1V14.9C14.9,15,14.9,15,15,15"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M14.9,14.9v257.2l-0.1,0.1V14.8C14.8,14.9,14.8,14.9,14.9,14.9"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M14.8,14.8v257.4l-0.1,0.1V14.7C14.7,14.8,14.7,14.8,14.8,14.8"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M14.7,14.7v257.6l-0.1,0.1V14.6C14.6,14.7,14.6,14.7,14.7,14.7"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M14.6,14.6v257.8l-0.1,0.1v-258C14.5,14.6,14.5,14.6,14.6,14.6"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M14.4,14.5v258l-0.1,0.1V14.4C14.4,14.4,14.4,14.5,14.4,14.5"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M14.3,14.4v258.2l-0.1,0.1V14.3C14.3,14.3,14.3,14.4,14.3,14.4"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M14.2,14.3v258.4l-0.1,0.1V14.2C14.2,14.2,14.2,14.3,14.2,14.3"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M14.1,14.2v258.7L14,273V14.1C14.1,14.1,14.1,14.2,14.1,14.2"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M14,14.1V273l-0.1,0.1V14C14,14,14,14.1,14,14.1"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M13.9,14v259.1l-0.1,0.1V13.9C13.8,13.9,13.9,14,13.9,14"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M13.8,13.9v259.3l-0.1,0.1V13.8C13.7,13.8,13.8,13.8,13.8,13.9"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M13.7,13.8v259.5l-0.1,0.1V13.7C13.6,13.7,13.7,13.7,13.7,13.8"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M13.6,13.7v259.7l-0.1,0.1V13.6C13.5,13.6,13.6,13.6,13.6,13.7"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M13.5,13.6v259.9l-0.1,0.1V13.5C13.4,13.5,13.5,13.5,13.5,13.6"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M13.4,13.5v260.1l-0.1,0.1V13.4C13.3,13.4,13.4,13.4,13.4,13.5"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M13.3,13.4v260.4l-0.1,0.1V13.3C13.2,13.3,13.2,13.3,13.3,13.4"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M13.2,13.3v260.6l-0.1,0.1V13.1C13.1,13.2,13.1,13.2,13.2,13.3"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M13.1,13.1v260.8L13,274V13C13,13.1,13,13.1,13.1,13.1"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M13,13v261l-0.1,0.1V12.9C12.9,13,12.9,13,13,13"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M12.9,12.9v261.2c-0.2,0.2-0.4,0.4-0.6,0.6V12.3C12.5,12.5,12.7,12.7,12.9,12.9"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M12.3,12.3v262.4c-0.3,0.3-0.5,0.5-0.8,0.8v-264C11.7,11.8,12,12.1,12.3,12.3"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M11.4,11.5v264c-0.1,0.1-0.2,0.2-0.3,0.3V11.2C11.3,11.3,11.3,11.4,11.4,11.5"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M11.2,11.2v264.6c-0.1,0.1-0.2,0.2-0.3,0.3V10.9C11,11,11.1,11.1,11.2,11.2"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M10.9,10.9v265.2c-0.1,0.1-0.2,0.2-0.3,0.3V10.7C10.7,10.8,10.8,10.8,10.9,10.9"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M10.6,10.7v265.7l-0.1,0.1v-266C10.5,10.6,10.5,10.6,10.6,10.7"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M10.5,10.5v266l-0.1,0.1L10.5,10.5C10.4,10.5,10.4,10.5,10.5,10.5"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M10.4,10.4v266.2l-0.1,0.1L10.4,10.4C10.3,10.4,10.3,10.4,10.4,10.4"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M10.3,10.4v266.4l-0.1,0.1L10.3,10.4C10.2,10.3,10.3,10.3,10.3,10.4"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M10.2,10.3v266.5l-0.1,0.1L10.2,10.3C10.1,10.2,10.2,10.2,10.2,10.3"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M10.1,10.2v266.7L10,277L10.1,10.2C10,10.1,10.1,10.1,10.1,10.2"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M10,10.1V277l-0.1,0.1L10,10.1C10,10,10,10.1,10,10.1"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M9.9,10v267.1l-0.1,0.1L9.9,10C9.9,9.9,9.9,10,9.9,10"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M9.8,9.9v267.2l-0.1,0.1L9.8,9.9L9.8,9.9"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M9.8,9.8v267.4l-0.1,0.1L9.8,9.8C9.7,9.8,9.7,9.8,9.8,9.8"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M9.7,9.7v267.6l-0.1,0.1L9.7,9.7C9.6,9.7,9.6,9.7,9.7,9.7"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M9.6,9.7v267.7l-0.1,0.1L9.6,9.7C9.5,9.6,9.6,9.6,9.6,9.7"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M9.5,9.6v267.9l-0.1,0.1L9.5,9.6C9.4,9.5,9.5,9.5,9.5,9.6"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M9.4,9.5v268.1l-0.1,0.1V9.4C9.3,9.4,9.4,9.4,9.4,9.5"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M9.3,9.4v268.4l-0.1,0.1V9.2C9.2,9.3,9.2,9.3,9.3,9.4"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M9.1,9.2v268.6L9,277.9V9.1C9.1,9.1,9.1,9.2,9.1,9.2"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M9,9.1V278l-0.1,0.1V9C8.9,9,9,9,9,9.1"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M8.9,9v269.1l-0.1,0.1V8.8C8.8,8.9,8.8,8.9,8.9,9"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M8.8,8.8v269.4l-0.1,0.1V8.7C8.7,8.7,8.7,8.8,8.8,8.8"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M8.6,8.7v269.7l-0.1,0.1V8.6L8.6,8.7"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M8.5,8.6v269.9c-0.1,0.1-0.2,0.2-0.3,0.3V8.3C8.3,8.4,8.4,8.5,8.5,8.6"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M8.2,8.3v270.5l-0.1,0.1V8.2C8.1,8.2,8.2,8.3,8.2,8.3"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M8.1,8.2v270.7L8,279V8C8,8.1,8,8.1,8.1,8.2"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M8,8v271l-0.1,0.1L8,8C7.9,7.9,7.9,8,8,8"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M7.8,7.9v271.3l-0.1,0.1L7.8,7.9C7.7,7.8,7.8,7.8,7.8,7.9"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M7.7,7.8v271.6l-0.1,0.1V7.6C7.6,7.7,7.6,7.7,7.7,7.8"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M7.5,7.6v271.8l-0.1,0.1L7.5,7.6C7.5,7.5,7.5,7.6,7.5,7.6"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M7.4,7.5v272.1l-0.1,0.1L7.4,7.5C7.3,7.4,7.4,7.4,7.4,7.5"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M7.3,7.4v272.3l-0.1,0.1L7.3,7.4C7.2,7.3,7.3,7.4,7.3,7.4"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M7.2,7.3v272.5l-0.1,0.1L7.2,7.3C7.2,7.2,7.2,7.3,7.2,7.3"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M7.1,7.2v272.7L7,280L7.1,7.2C7.1,7.1,7.1,7.2,7.1,7.2"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M7,7.1v272.8c0,0.1,0,0.1,0,0.1V7.1L7,7.1"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M7,7v273l-0.1,0.1L7,7C6.9,7,6.9,7,7,7"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M6.9,6.9v273.2l-0.1,0.1L6.9,6.9C6.8,6.9,6.8,6.9,6.9,6.9"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M6.8,6.9v273.3l-0.1,0.1L6.8,6.9C6.7,6.8,6.8,6.8,6.8,6.9"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M6.7,6.8v273.5l-0.1,0.1L6.7,6.8C6.6,6.7,6.7,6.7,6.7,6.8"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M6.6,6.7v273.7l-0.1,0.1L6.6,6.7C6.6,6.6,6.6,6.7,6.6,6.7"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M6.5,6.6v273.9l-0.1,0.1L6.5,6.6C6.5,6.5,6.5,6.6,6.5,6.6"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M6.4,6.5v274l-0.1,0.1L6.4,6.5C6.4,6.4,6.4,6.5,6.4,6.5"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M6.3,6.4v274.3c-0.1,0.1-0.1,0.1-0.2,0.2V6.2C6.2,6.3,6.3,6.3,6.3,6.4"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M6.1,6.2v274.6c0,0.1-0.1,0.2-0.1,0.2V6C6,6.1,6.1,6.2,6.1,6.2"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M6,6v275c-0.1,0.1-0.1,0.1-0.2,0.2V5.9C5.9,5.9,5.9,6,6,6"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M5.8,5.9v275.3c-0.1,0.1-0.1,0.1-0.2,0.2V5.7C5.7,5.8,5.7,5.8,5.8,5.9"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M5.6,5.7v275.7c-0.1,0.1-0.2,0.2-0.3,0.3V5.4C5.4,5.5,5.5,5.6,5.6,5.7"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M5.3,5.4v276.3c-0.5,0.5-1,1-1.4,1.4V3.9C4.3,4.4,4.8,4.9,5.3,5.4"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3.9,3.9v279.2c-0.4,0.4-0.8,0.8-1.2,1.2V2.8C3,3.1,3.4,3.5,3.9,3.9"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2.7,2.8v281.6c-0.2,0.2-0.5,0.5-0.7,0.7V2.1C2.2,2.3,2.4,2.5,2.7,2.8"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2,2.1V285c-0.2,0.2-0.4,0.4-0.6,0.6V1.5C1.6,1.7,1.8,1.9,2,2.1"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1.4,1.5v284.1c-0.2,0.2-0.4,0.4-0.5,0.5V1C1,1.1,1.2,1.3,1.4,1.5"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0.9,1v285.1c-0.2,0.2-0.3,0.3-0.4,0.4V0.6C0.6,0.7,0.7,0.8,0.9,1"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0.5,0.6v285.9c-0.1,0.1-0.2,0.2-0.2,0.2V0.4C0.3,0.4,0.4,0.5,0.5,0.6"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.3,0.4v286.4l0,0V0.4C0.3,0.3,0.3,0.3,0.3,0.4"
  })))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.9,
    y: 8.9,
    className: "st9",
    width: 269.2,
    height: 269.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-15,182.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-15,182.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M146.9,183.4H91.4l-42.2,76.2H25L150.4,39.3h19.2l3.8,226h-25.9l-0.5-76.9L146.9,183.4z M147.6,162.6l1.6-84 h-0.4l-47.2,87.5l45.7,0.4L147.6,162.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M56.9,190.6c-2.9-3.1-9.3-5.7-14.1-5.7c-7.2,0-7.2,0-9.2-7.9c1-0.6,2.2-1.3,3.3-2c5.9-3.8,8.3-9.3,7.2-16.1 c-1.1-6.5-5-11.1-11.5-12.2c-5-0.8-5.5-3.6-4.8-7.3c0.2-1.3,1.6-3,2.7-3.3c7.3-1.5,12.4-5.3,13.6-12.9c1.3-8-1.5-12.8-9.6-17.4 c-0.3-0.1-0.4-0.4-1-0.9c0.6-1.7,1.2-3.5,1.8-5.4c0.7-2.2,1.8-3,4.4-2.6c7.6,1.3,13.7-1.6,16.8-7.4c3.5-6.5,2.7-12.8-2.6-19 c-0.4-0.5-0.7-0.9-1.3-1.7c2-2.4,3.9-4.7,5.9-7.1c7.1,4.9,14.3,5.9,21,0.3c6.7-5.6,7-12.8,3.3-20.8c2.7-1.6,5.3-3.1,8-4.6 c1.3,1.4,2.2,2.6,3.3,3.7c4.7,4.7,10.3,6,16.4,3.9c6.2-2.2,10.2-6.8,10-13.4c-0.2-5.5,3-6,6.7-6c1.2,0,3.1,1.3,3.6,2.4 c2.8,6.5,7.1,10.5,14.5,10.6c7.8,0.2,12.7-3.8,15.3-10.7c1.4-3.8,4.1-2.3,6.5-2.1c2,0.2,3.8,0.6,3.7,3.5 c-0.2,7.7,3.2,13.3,10.7,15.8c7.7,2.5,13.8-0.3,18.4-6.7c0.2-0.2,0.5-0.3,1.1-0.7c2.3,1.3,4.8,2.7,7.5,4.3c-0.5,1.5-0.9,2.7-1.3,4 c-2,6.1-0.8,11.6,3.7,16.1c4.7,4.7,10.5,5.5,16.6,3.5c6.8-2.2,6.8-2.4,11.2,4.4c-4.1,3.9-6.6,8.6-5.7,14.6 c1.3,9,8.8,14.9,18.1,13.2c4.5-0.8,4.7,2.1,5.9,4.5c1.4,2.8,0.2,4.3-2.4,5.7c-5.6,3.2-8.6,10-7.5,16c1.2,6.6,6.1,11.8,12.9,12.5 c4,0.4,3.8,2.6,3.8,5.3s0.1,5-3.8,5.4c-7.1,0.8-11.1,5.4-12.7,12.1c-1.4,6.2,0.7,11.5,5.7,15.4c5.5,4.3,5.6,4.4,1.4,11.5 c-8.4-1.8-16-0.3-20.1,8.2c-3.5,7.2-1.3,13.7,4.7,19.4c-2.2,2.6-4,4.8-6,7.3c-7.3-4.7-14.6-6.1-21.5,0c-6.3,5.6-6.4,12.4-3,20.2 c-1.7,1.1-3.3,2.6-5.2,3.2c-1.3,0.4-3.6,0.1-4.4-0.8c-4.9-5.3-10.7-7.8-17.7-5.3s-10.6,7.8-10.3,15.1c0.2,4.2-2.7,3.8-5,4.3 c-2.2,0.5-4.3,0.9-5.4-2.4c-2.3-6.7-7.2-10.5-14.5-10.6c-7.4-0.1-12.5,3.5-15,10.5c-0.9,2.3-2.1,3.2-4.4,2.7 c-1.9-0.4-3.9-0.7-5.8-1.1c-0.1-2.1-0.1-3.9-0.3-5.7c-0.6-6.1-3.9-10.2-9.4-12.5c-5.7-2.3-11.1-1.4-15.9,2.6 c-5.6,4.7-5.6,4.7-12.2,0c3.4-8.2,3.7-15.9-4.6-21.4l6.8-13.4c16.2,14.8,38.5,24,62.8,23.8c47.7-0.4,86.7-40.7,86.3-89 c-0.4-49.1-39.7-88.4-88.1-88c-46.1-1.2-89.2,37-89,89.1c0,14,1.9,25.4,7.8,37.1L56.9,190.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.2,166.9l-16.3,49.3H340l53.2-156.6h24.4l53.5,156.6h-21.6l-16.7-49.3H377.2z M428.5,151.1L413.2,106 c-3.5-10.2-5.8-19.5-8.1-28.6h-0.5c-2.3,9.3-4.9,18.8-7.9,28.4l-15.3,45.3H428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.7,51.2v135.9c0,10,0.2,21.4,0.9,29h-18.4l-0.9-19.5h-0.5c-6.3,12.5-20,22.1-38.3,22.1c-27.2,0-48.1-23-48.1-57.2 c-0.2-37.4,23-60.4,50.4-60.4c17.2,0,28.8,8.1,33.9,17.2h0.5V51.2H587.7z M567.3,149.5c0-2.6-0.2-6-0.9-8.6 c-3-13-14.2-23.7-29.5-23.7c-21.1,0-33.7,18.6-33.7,43.5c0,22.8,11.2,41.6,33.2,41.6c13.7,0,26.3-9.1,30-24.4 c0.7-2.8,0.9-5.6,0.9-8.8V149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.7,51.2h20.5v165h-20.5V51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.8,216.2l-1.6-14.2h-0.7c-6.3,8.8-18.4,16.7-34.4,16.7c-22.8,0-34.4-16-34.4-32.3c0-27.2,24.2-42.1,67.6-41.8v-2.3 c0-9.3-2.6-26-25.6-26c-10.5,0-21.4,3.3-29.3,8.4l-4.6-13.5c9.3-6,22.8-10,37-10c34.4,0,42.8,23.5,42.8,46v42.1 c0,9.8,0.5,19.3,1.9,27H738.8z M735.8,158.8c-22.3-0.5-47.6,3.5-47.6,25.3c0,13.2,8.8,19.5,19.3,19.5c14.6,0,23.9-9.3,27.2-18.8 c0.7-2.1,1.2-4.4,1.2-6.5V158.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.2,71.4v32.3h29.3v15.6h-29.3v60.7c0,13.9,4,21.8,15.3,21.8c5.3,0,9.3-0.7,11.9-1.4l0.9,15.3 c-4,1.6-10.2,2.8-18.1,2.8c-9.5,0-17.2-3-22.1-8.6c-5.8-6-7.9-16-7.9-29.3v-61.4h-17.4v-15.6h17.4v-27L812.2,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.6,185.5c0,11.6,0.2,21.8,0.9,30.7h-18.1l-1.2-18.4h-0.5c-5.3,9.1-17.2,20.9-37.2,20.9c-17.7,0-38.8-9.8-38.8-49.3 v-65.8h20.5V166c0,21.4,6.5,35.8,25.1,35.8c13.7,0,23.2-9.5,27-18.6c1.2-3,1.9-6.7,1.9-10.5v-69h20.5V185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.8,195.3c6,4,16.7,8.1,27,8.1c14.9,0,21.8-7.4,21.8-16.7c0-9.8-5.8-15.1-20.9-20.7c-20.2-7.2-29.7-18.4-29.7-31.8 c0-18.1,14.6-33,38.8-33c11.4,0,21.4,3.3,27.7,7l-5.1,14.9c-4.4-2.8-12.5-6.5-23-6.5c-12.1,0-18.8,7-18.8,15.3 c0,9.3,6.7,13.5,21.4,19.1c19.5,7.4,29.5,17.2,29.5,33.9c0,19.8-15.3,33.7-42.1,33.7c-12.3,0-23.7-3-31.6-7.7L989.8,195.3z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdlatusLogo);
export default __webpack_public_path__ + "static/media/adlatus_Logo.ab38dc261429a4c9c540b246699cd890.svg";
export { ForwardRef as ReactComponent };